import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { UserCreationFiduciaryComponent } from "../Canales/UserFiduciary/user-creation-fiduciary/user-creation-fiduciary.component";
import { DashboardFiduciaryAdminComponent } from "../Canales/UserFiduciary/Dashboard/dashboard-user-fiduciary.component";
import { EditUserFiduciaryComponent } from "../Canales/UserFiduciary/EditUser/edit-user-fiduciary.component";

import permisos from "../../assets/constantes/permisos.json";
import { UserHasPermissionGuard } from "../../shared/Guards/user-has-permission.guard";
import { getRouteSection } from "@shared/Utils/get-route-details.util";

const getPageDetails = getRouteSection("canales");

const routes: Routes = [
  {
    path: "creacion",
    loadChildren: () => import("./RequestCreation/request-creation.module").then((m) => m.RequestCreationModule),
  },
  {
    path: "consulta",
    loadChildren: () => import("./RequestSearch/fiduciary-request-search.module").then((m) => m.FiduciarySearchModule),
  },
  {
    path: "",
    children: [
      {
        path: "fiduciary-manage-users",
        component: DashboardFiduciaryAdminComponent,
        canActivate: [UserHasPermissionGuard],
        data: {
          title: "Gestión de usuarios Fiduciaria",
          requiredPermission: permisos.CanalesFiduciaria.FiduciaryCorporate,
        },
      },
      {
        path: "fiduciary-manage-users/operational",
        component: DashboardFiduciaryAdminComponent,
        canActivate: [UserHasPermissionGuard],
        data: {
          title: "Gestión de usuarios Fiduciaria",
          requiredPermission: permisos.CanalesFiduciaria.FiduciaryOperational,
        },
      },
      {
        path: "create-fiduciary-user-canales/operational",
        component: UserCreationFiduciaryComponent,
        canActivate: [UserHasPermissionGuard],
        data: {
          title: "Creacion de usuarios fiduciaria",
          requiredPermission: permisos.CanalesFiduciaria.FiduciaryOperational,
        },
      },
      {
        path: "create-fiduciary-user-canales",
        component: UserCreationFiduciaryComponent,
        canActivate: [UserHasPermissionGuard],
        data: {
          title: "Creacion de usuarios fiduciaria",
          requiredPermission: permisos.CanalesFiduciaria.FiduciaryCorporate,
        },
      },
      {
        path: "editar-usuario-fiduciaria/operational/:id",
        component: EditUserFiduciaryComponent,
        ...getPageDetails("userCreation"),
        canActivate: [UserHasPermissionGuard],
        data: {
          title: "Creacion de usuarios fiduciaria",
          requiredPermission: permisos.CanalesFiduciaria.FiduciaryOperational,
        },
      },
      {
        path: "editar-usuario-fiduciaria/:id",
        component: EditUserFiduciaryComponent,
        ...getPageDetails("userCreation"),
        canActivate: [UserHasPermissionGuard],
        data: {
          title: "Creacion de usuarios fiduciaria",
          requiredPermission: permisos.CanalesFiduciaria.FiduciaryCorporate,
        },
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FiduciariaRoutingModule {}
